import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/safiruni/front/components/Articles/DescriptionSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/safiruni/front/components/Articles/TopSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/front/safiruni/front/components/Home/ScrollToTop .tsx");
;
import(/* webpackMode: "eager" */ "/var/www/front/safiruni/front/public/images/bgLinear.png");
